type TLoading = 'init'|'loading'|'loaded'
/** INTERFACES FROM SERVER */


/** Base Class to extend */
export class Route {
    public loading: TLoading
    constructor(loading?: TLoading) {
        if (!loading) {
            this.loading = 'init'
        } else {
            this.loading = loading
        }
    }
    
}

export interface IFixtureModel {
    homeTeam: string,
    awayTeam: string,
    date: string,
    time: string
}

export interface IMatchModel {
    matchId: number
    homeTeam: string
    awayTeam: string
    date: string
    odds?: IOddsModel
    open: boolean
    homeAway: number
}

export interface IOddsModel {
    correctScore: IOdds[],
    accumulator: IAccumulatorOdds,
    goalscorers?: IGoalscorersOdds
}

export interface IAccumulatorOdds {
    over?: IOdds,
    under?: IOdds,
    btts?: IOdds,
    draw?: IOdds
}

export interface IOdds {
    id?: number,
    odds?: any,
    odds1X2?: number,
    bonus?: number,
    outCome: number,
    name: string,
    specialBetValue?: number
}

export interface IGoalscorersOdds {
    homeTeam: IOdds[],
    awayTeam: IOdds[]
}

export interface IRoundModel {
    roundName: string,
    roundId: number,
    deadline: string,
    prizes: number[],
    played: boolean
}

export interface IBet {
    playerId?: number,
    round?: number,
    correctScores?: ICorrectScoreBet[],
    accumulator?: ICorrectScoreBet[],
    goalscorers?: ICorrectScoreBet[],
}

export interface ICorrectScoreBet {
    matchId: number,
    homeTeam: string,
    awayTeam: string,
    correctScore: IOdds,
    type?: string,
    team?: number
}

export interface IGoalscorersBet {
    matchId: number,
    goalscorers: IGoalscorersOdds
}

export interface IResultModel {
    playerId?: number,
    username?: string,
    nationality?: string,
    correctScores: ICorrectScoreModel[],
    accumulator: ICorrectScoreModel[],
    goalscorers: ICorrectScoreModel[]
}

export interface ICorrectScoreModel {
    matchId: number,
    homeTeam: string,
    awayTeam: string,
    odds: IOdds,
    chosenBet: string,
    result: string,
    points: number,
    isWin: boolean
}

export interface IUser {
    firstName?: string
    lastName?: string
    email?: string
    username: string
    password?: string
    nationality?: string
    subscription?: boolean
}

export interface IFlags {
    name: string
    image40: string
}

export interface ILeaderboardsModel {
    leaderboard: ILeaderboardsRow[],
    playerStats: ILeaderboardsRow
}

export interface ILeaderboardsRow {
    playerId?: number,        
    position?: number,
    player: string,
    nationality: string,
    correctScorePoints?: number,
    accumulatorPoints?: number,
    goalscorersPoints?: number,
    totalPoints?: number
}

/* CLASS EXTENDS ROUTE IMPLEMENTS INTERFACE FROM SERVER ALWAYS INITIALIZE OBJECTS */
export class Rounds extends Route {
    Route: IRoundModel[]
}

export class Matches extends Route {
    Route: IMatchModel[]
}

export class InsertBet extends Route {
    Route: {}
}

export class UpdateBet extends Route {
    Route: {}
}

export class Results extends Route {
    Route: IResultModel
}

export class Login extends Route {
    Route: {}
}

export class ForgotPassword extends Route {
    Route: {}
}

export class ChangePassword extends Route {
    Route: {}
}

export class Unsubscribe extends Route {
    Route: {}
}

export class MyProfileSelect extends Route {
    Route: {}
}

export class MyProfileUpdate extends Route {
    Route: {}
}

export class Registration extends Route {
    Route: IUser
}

export class UserConfirmation extends Route {
    Route: {}
}

export class Flags extends Route {
    Route: IFlags
}

export class Leaderboards extends Route {
    Route: ILeaderboardsModel
}

export class CreateLeague extends Route {
    Route: {}
}

export class JoinLeague extends Route {
    Route: {}
}

export class SendLeagueCode extends Route {
    Route: {}
}

export class UserLeagues extends Route {
    Route: {}
}

export class UpcomingFixtures extends Route {
    Route: IFixtureModel[]
}

export class Usr extends Route {
    username: string
}

export class LeaderboardFeed extends Route {
    Route: {}
}

export class TeamFeed extends Route {
    Route: {}
}

export class PlayerFeed extends Route {
    Route:  {}
}

export class LastMatchesFeed extends Route {
    Route: {}
}



// WEBPACK FOOTER //
// ./src/Socket/route-classes.ts